<p-card *ngFor="let pMethod of paymentMethods" class="field-checkbox" styleClass="w-full payment-method-card">
    <div class="flex justify-content-between">
        <label for="{{pMethod.id}}" class="ml-2 w-full flex justify-content-between">
            <div>
                {{ pMethod.name }} @if(pMethod.payment_method_type != 'ACH') { ({{ pMethod.last_digit }}) }
                <br />
                @if(pMethod.payment_method_type == 'Credit Card') {
                Exp: {{pMethod.exp_month}}/{{pMethod.exp_year}}
                }
                @else if(pMethod.payment_method_type == 'eCheck') {
                Name #: {{ pMethod.account_name }}
                <br />
                Routing #: {{ pMethod.routing_number }}
                }
            </div>

            <div class="flex align-items-center pr-2">
                <p-tag value="Service charge {{ pMethod.service_charge }}%" severity="success" />
            </div>

        </label>
        <p-radioButton name="pMethod" inputId="{{pMethod.id}}" [value]="pMethod" [(ngModel)]="selectedPaymentMethod"
            [autofocus]="pMethod.is_default" (onClick)="paymentMethodChanged($event)" />
    </div>
</p-card>
<p-card class="field-checkbox" styleClass="w-full payment-method-card" *ngIf="isPaymentEnabled">
    <div class="flex justify-content-between">
        <label for="new-method" class="ml-2">Add New Payment Method</label>
        <p-radioButton name="pMethod" inputId="new-method" [value]="'new'" [(ngModel)]="selectedPaymentMethod"
            (onClick)="paymentMethodChanged($event)" />
    </div>
</p-card>
<p-messages key="payment-form-error-message" />
<div *ngIf="isNewPaymentMethod" class="pt-5">
    <new-payment-method-form [tokenizationSourceKey]="tokenizationSourceKey"
        (paymentMethodDetailsEvent)="newPaymentMethodDetails($event)" [echeckPaymentEnabled]="AllowCheckMethod"></new-payment-method-form>
</div>